export const IncidentsViewTabsData = [{ label: 'Incident' }, { label: 'Documents' }];
